import { Route } from "@/types/routes"
import { defaultShouldRedirect, defaultRedirectTo } from "./shared"

export const affiliateRoute: Route = {
  isPublic: false,
  shouldRedirect: (params) => params.isSupportRole ? true : defaultShouldRedirect(params),
  redirectTo: defaultRedirectTo,
}
